<template>
  <div class="emails">
    <ba-header activeModule="Insured Messages"></ba-header>
    <div class="u-p4 main-content">
      <h2 class="c-heading__page u-mt4 u-pt2">Broadcast Message</h2>
      <div class="u-text--light">This message will be delivered to all enrolled users unless a specific group of users is chosen below.</div>
      <ba-send-insured-message :message-audience="'company'" :company-id="companyId"/>
    </div>
  </div>

</template>

<script>
  import BaNewInsuredMessageForm from '@/modules/messages/send-insured-message.component'

  export default {
    components: {
      'ba-send-insured-message': BaNewInsuredMessageForm,
    },
    name: 'ba-new-campaign',
    data () {
      return {
        companyId: this.$route.params.companyId,
      }
    },
  }
</script>

<style>
  .group__selection > .el-select {
    width: 15%;
  }
</style>

